import React from 'react';
import { Link } from 'react-router-dom';
import './PageHero.css';

const PageHero = ({ title }) => {
  return (
    <section className="page-hero">
      <div className="page-hero-overlay"></div>
      <div className="page-hero-content">
        <h1 className="page-hero-title fade-up">{title}</h1>
        <div className="page-breadcrumb fade-up stagger-1">
          <Link to="/">Home</Link>
          <span> {'>'} </span>
          <span>{title}</span>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
